import Routers from "./Routers";
import { ToastContainer } from "react-toastify";
import "./Assets/css/global.css";

const App = () => {
  return (
    <>
      <Routers />

      <ToastContainer
        theme="light"
        position="top-right"
        autoClose={2000}
        pauseOnHover
        draggable
        toastStyle={{ textTransform: "capitalize" }}
      />
    </>
  );
};

export default App;
